export default "__VITE_ASSET__qDkrWqix__"